import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useCsCfgObject } from "@plansoft-configuration-renderer/framework";
import { ConfigurationObjectInfo, INFO_LAYOUT_PROPS_DEFAULTS, } from "../Info";
export function ConfigurationHeadline(props) {
    var _a;
    const { infoProps = INFO_LAYOUT_PROPS_DEFAULTS } = props;
    const cfgObject = useCsCfgObject();
    const labelText = (_a = cfgObject.name) !== null && _a !== void 0 ? _a : cfgObject.id;
    return (_jsxs(Box, { className: "configuration-headline", sx: {
            my: 2,
            display: "flex",
            alignItems: "center",
        }, children: [_jsx(Typography, { variant: "h3", color: "primary", children: labelText }), _jsx(ConfigurationObjectInfo, Object.assign({}, infoProps))] }));
}
ConfigurationHeadline.displayName = "ConfigurationHeadline";
//# sourceMappingURL=ConfigurationHeadline.js.map